import { Dialog, Flex } from '@radix-ui/themes'
import { usePlayWallet } from 'shared/hooks/use-play-wallet'
import { DialogShared } from 'shared/ui'
import { useLinkWallet } from '../hooks/use-link-wallet'
import { useWalletBalances } from '../hooks/use-wallet-balances'
import { isWalletsDialogOpenVar } from '../store/dialogs'
import { LinkWalletSection } from './link-wallet-section'
import { PlayWalletNotice } from './play-wallet-notice'
import { WalletListItem } from './wallet-list-item'

export const WalletsDialog: React.FC = () => {
  const { wallets, selectedAddress, connectedAddress, status, selectWallet } =
    usePlayWallet()
  const { linkConnectedWallet, linkProviderWallet, isLinking } = useLinkWallet()
  const balances = useWalletBalances()

  return (
    <DialogShared
      openStore={isWalletsDialogOpenVar}
      width='64rem'
    >
      <Flex
        direction='column'
        gap='5'
      >
        <Dialog.Title mb='0'>Your wallets</Dialog.Title>

        <PlayWalletNotice
          status={status}
          connectedAddress={connectedAddress}
          isLinking={isLinking}
          onLinkConnected={linkConnectedWallet}
          onSelectConnected={selectWallet}
        />

        <Flex
          direction='column'
          gap='3'
        >
          {wallets.map(wallet => (
            <WalletListItem
              key={wallet.id}
              address={wallet.address}
              isPrimary={wallet.isPrimary}
              isSelected={wallet.address === selectedAddress}
              isConnected={wallet.address === connectedAddress}
              balance={balances[wallet.address]}
              onSelect={selectWallet}
            />
          ))}
        </Flex>

        <LinkWalletSection
          isLinking={isLinking}
          onLink={linkProviderWallet}
        />
      </Flex>
    </DialogShared>
  )
}
